import React from "react";
import * as authApi from "api/auth";
import { useLocation, useNavigate } from "react-router-dom";
import MainContext from "contexts/main";
import Loading from "components/loading";
const RequireAuth = ({ children }) => {
  let navigate = useNavigate();
  let location = useLocation();
  const [status, setStatus] = React.useState("loading");
  const { user, setUser } = React.useContext(MainContext);
  React.useEffect(() => {
    if (user) {
      setStatus("loaded");
    } else {
      let token = localStorage.getItem("token");
      if (token) {
        authApi
          .profile()
          .then((res) => {
            setUser({ ...res.data, token: token });
            setStatus("loaded");
          })
          .catch(() => {
            navigate("/auth", { replace: true, from: location });
          });
      } else {
        navigate("/auth", { replace: true, from: location });
      }
    }
  }, [user]);
  if (!user) {
    navigate("/auth", { replace: true, from: location });
    return null;
  }
  if (status === "loading") {
    return <Loading />;
  }
  return children;
};
export default RequireAuth;
